// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { slideshowStyles } from "@guestsupply/Overrides/Widgets/Basic/Slideshow";
import { color, mergeWithCss, xScreen } from "@guestsupply/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

slideshowStyles.slideshowWrapper = {
    css: css`
        position: relative;
    `,
};

slideshowStyles.prevArrowButton = {
    css: css`
        background: ${color("common.ui6")};
        opacity: 0.66;
        border: 0;
        border-radius: 0;
        height: 66px;
        padding: 20px 8px;

        & > ${IconWrapper} {
            color: ${color("common.white")};
            &,
            & > svg {
                height: 26px;
            }
        }

        ${xScreen("lte", "sm")} {
            display: none;
        }
    `,
};

slideshowStyles.nextArrowButton = {
    css: css`
        background: ${color("common.ui6")};
        opacity: 0.66;
        border: 0;
        border-radius: 0;
        height: 66px;
        padding: 20px 8px;

        & > ${IconWrapper} {
            color: ${color("common.white")};
            &,
            & > svg {
                height: 26px;
            }
        }

        ${xScreen("lte", "sm")} {
            display: none;
        }
    `,
};

slideshowStyles.iconProps = {
    size: 16,
};

slideshowStyles.dotButton = {
    css: css`
        flex: 1 1 0;
        min-height: auto;
        height: 6px;
        border: 0;
        border-radius: 0;
        background: ${getColor("common.ui5")};
        &:hover,
        &:active {
            background: ${getColor("common.ui8")};
        }
    `,
};

slideshowStyles.dotsContainerWrapper = {
    css: css`
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 6px;
        margin-top: 8px;
    `,
};

slideshowStyles.pauseIcon = {
    size: 12,
    color: "primary",
    css: css`
        &:hover {
            svg {
                color: ${color("common.ui8")};
            }
        }
    `,
};

slideshowStyles.slideOverlayWrapper = {
    ...slideshowStyles.slideOverlayWrapper,
    css: css`
        width: 100%;
        ${xScreen("lte", "sm")} {
            display: block;
            padding: 0;
        }
    `,
};

slideshowStyles.slideContentWrapper = {
    ...mergeWithCss(slideshowStyles.slideContentWrapper, {
        css: css`
            ${xScreen("lte", "sm")} {
                background-image: none;
                aspect-ratio: auto;
            }
        `,
    }),
};

slideshowStyles.imageStyles = {
    css: css`
        display: none;
        ${xScreen("lte", "sm")} {
            display: block;
            width: 100%;
            height: auto;
            max-height: 270px;
            margin-bottom: 8px;
        }
    `,
};

const sharedArrowWrapper: InjectableCss = {
    css: css`
        position: absolute;
        z-index: 1;
        top: 50%;
        transform: translate(0, -50%);
    `,
};

slideshowStyles.prevArrowWrapper = {
    ...sharedArrowWrapper,
};

slideshowStyles.nextArrowWrapper = {
    css: css`
        ${sharedArrowWrapper.css}
        right: 0;
    `,
};
